const WidgetSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'rgba(196, 196, 196, 1)', // 🔁 updated here
    borderRadius: '5px',
    // border: '1px solid #F5F5F5',
    border: '2px solid #fff', // 🔵 Blue border
    minHeight: '22px',
    height: '22px',
    width: '120px',
    fontSize: '11px',
    padding: 0,
    margin: 0,
    boxShadow: 'none',
    borderColor: state.isFocused ? '#fff' : '#fff',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 0px',
    alignItems: 'center', 
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '22px',
  }),
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    // backgroundColor: state.isFocused ? 'rgba(180, 180, 180, 0.95)' : 'rgba(196, 196, 196, 0.95)', // 🔁 optional update
    // color: '#000',
    backgroundColor: state.isFocused ? '#C4C4C4' : '#0C1A2C', 
    color: state.isFocused ? '#040811' : '#fff',
    fontWeight: state.isFocused ? 700 : 'normal',
    // color: '#FFF',
    fontSize: '10px',
    //padding: '6px 10px',
    margin: 0,
    padding: '2px 8px',
    lineHeight: '1.4',
    // fontWeight: 'normal',
    height: '25px', 
    ':active': {
      backgroundColor:'#C4C4C4',
      color: '#040811',
    },

    // 💥 Remove outline (sometimes adds blue halo)
    outline: 'none',  
  }),
  singleValue: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    color: '#000', // 🔁 for contrast on light background
    fontSize: '11px',
    fontWeight: 'bold', 
    paddingLeft: '8px',
    paddingRight: '2px',
    margin: 0,
    height: '22px',
    whiteSpace: 'nowrap',      // 👈 Prevent wrapping
    overflow: 'hidden',        // 👈 Hide overflow
    textOverflow: 'ellipsis',  // 👈 Show ellipsis
    maxWidth: '100%', 
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0px',
    color: '#333',
    ':hover': {
      color: '#333', // ensure color stays the same on hover too
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
    alignItems: 'center',
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#040811',
    // backgroundColor: 'rgba(196, 196, 196, 0.95)', // 🔁 updated here
    borderRadius: '4px',
    marginTop: 2,
    border: '1px solid #ffffff', // ✅ white border around the entire dropdown
    boxShadow: 'none', // optional: remove react-select default shadow
    zIndex: 100000
  }),
  menuList: (base) => ({
    ...base,
    // backgroundColor: 'rgba(196, 196, 196, 0.95)', // 🔁 updated here
    backgroundColor: '#040811',
    borderRadius: '8px',
    padding: 1,
    maxHeight: '200px', // 👈 set desired max height here
    overflowY: 'auto',        // ✅ Allow auto height
  }),
};

export default WidgetSelectStyles;
